var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.id}},[_c('p',{staticClass:"has-text-centered pb-4 is-size-4 has-text-weight-bold",class:_vm.classe},[_vm._v("REMINDER: "+_vm._s(_vm.data.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }